import NavTopContainer from './nav_top_container';

const NavTop = NavTopContainer;
export default NavTop;
